import { DEFAULT_ISLAND_KEY, resolveIslandArea } from 'alakai-aloha-shared';

const CANONICAL_AREA_MAP = new Map([
  ['anahola', 'Anahola'],
  ['eleele', 'Hanapēpē'],
  ['haena', 'Hāʻena'],
  ['hanalei', 'Hanalei'],
  ['hanapepe', 'Hanapēpē'],
  ['kalaheo', 'Lāwaʻi & Kalāheo'],
  ['kapaa', 'Kapaʻa'],
  ['kekaha', 'Kekaha'],
  ['kilauea', 'Kīlauea'],
  ['koloa', 'Kōloa'],
  ['lawai', 'Lāwaʻi & Kalāheo'],
  ['lihue', 'Līhuʻe'],
  ['mauna-kea-beach', 'Mauna Kea Beach'],
  ['mauna-kea-summit', 'Mauna Kea Summit'],
  ['mauna-loa-summit', 'Mauna Loa Summit'],
  ['poipu', 'Poʻipū'],
  ['princeville', 'Princeville'],
  ['wailua', 'Wailua'],
  ['wailua-homesteads', 'Wailua'],
  ['waimea', 'Waimea'],
  ['waimea-canyon-kokee', 'Waimea Canyon & Kōkeʻe'],
]);

function makeLookupKey(value) {
  return value
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[ʻ'`]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

function toTitleCase(value) {
  return value
    .split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function canonicalizeIslandAreaName(value, islandKey = DEFAULT_ISLAND_KEY) {
  if (!value) return value;
  const resolvedArea = resolveIslandArea(value, islandKey);
  if (resolvedArea?.title) {
    return resolvedArea.title;
  }

  const key = makeLookupKey(value);
  const canonical = CANONICAL_AREA_MAP.get(key);
  return canonical || toTitleCase(value);
}

export function canonicalizeAreaName(value) {
  return canonicalizeIslandAreaName(value, DEFAULT_ISLAND_KEY);
}
